import React from 'react'
import { Card, CardMedia, CardContent, CardHeader, withStyles, IconButton, CardActions, Collapse, Typography, Grid } from '@material-ui/core'
import clsx from 'clsx'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    media: {
        paddingTop: '100%',
        height: 0,
        cursor: 'pointer',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    grid: {
        transition: 'all 0.5s',
    }
})

class StaffCard extends React.Component {

    state = {
        expanded: false
    }

    handleExpandClick = (e) => {
        this.setState({ expanded: !this.state.expanded })
    }
    render() {
        const { staffMember, classes } = this.props
        return (
            <Grid className={classes.grid} item md={ this.state.expanded ? 12 : 4 } sm={ this.state.expanded ? 12 : 6 } xs={12}>
                <Card>
                    <CardHeader
                        title={staffMember.name} 
                        subheader={staffMember.title ? staffMember.title : ''} />
                    <CardMedia
                        className={classes.media}
                        image={staffMember.imageURL ? staffMember.imageURL : ''} 
                        onClick={this.handleExpandClick}
                        title={staffMember.name} />
                    <CardActions disableSpacing>

                        <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: this.state.expanded,
                        })}
                        onClick={this.handleExpandClick}
                        aria-expanded={this.state.expanded}
                        aria-label="show more"
                        >
                        <ExpandMoreIcon />
                        </IconButton>
                    </CardActions>
                    <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                        <CardContent>
                            {staffMember.position ? <Typography variant="body1"> <b>Position:</b>  {staffMember.position} </Typography> : ''}
                            {staffMember.email ? <Typography variant="body1"> <b>Email:</b>  {staffMember.email} </Typography> : ''}
                            {staffMember.bio ? <Typography variant="body1"> <b>Biography:</b>  {staffMember.bio} </Typography> : ''}
                            {staffMember.education ? <Typography variant="body1"> <b>Education:</b>  {staffMember.education.map(e => <li>{e}</li>)} </Typography> : ''}
                            {staffMember.research_interests ? <Typography variant="body1"> <b>Research Interests:</b>  {staffMember.research_interests.map(i => <li>{i}</li>)} </Typography> : ''}
                            {staffMember.journalArticles ? <Typography variant="body1"> <b>Journal Articles:</b>  {staffMember.journalArticles.map(i => <li>{i}</li>)} </Typography> : ''}
                            {staffMember.publications ? <Typography variant="body1"> <b>Publications:</b>  {staffMember.publications} </Typography> : ''}
                            {staffMember.fields_interest ? <Typography variant="body1"> <b>Fields of Interest:</b>  {staffMember.fields_interest} </Typography> : ''}
                            {staffMember.awards ? <Typography variant="body1"> <b>Awards:</b>  {staffMember.awards.map(i => <li>{i}</li>)} </Typography> : ''}
                            {staffMember.skills ? <Typography variant="body1"> <b>Skills:</b>  {staffMember.skills} </Typography> : ''}
                            {staffMember.memberships ? <Typography variant="body1"> <b>Memberships:</b>  {staffMember.memberships} </Typography> : ''}
                            {staffMember.experience ? <Typography variant="body1"> <b>Experience:</b>  {staffMember.experience} </Typography> : ''}
                            {staffMember.achievements ? <Typography variant="body1"> <b>Achievements:</b>  {staffMember.achievements.map(i => <li>{i}</li>)} </Typography> : ''}
                            {staffMember.vision ? <Typography variant="body1"> <b>Vision:</b>  {staffMember.vision} </Typography> : ''}
                            {staffMember.mission ? <Typography variant="body1"> <b>Mission:</b>  {staffMember.mission.map(i => <li>{i}</li>)} </Typography> : ''}
                            {staffMember.hobbies ? <Typography variant="body1"> <b>Hobbies:</b>  {staffMember.hobbies.map(i => <li>{i}</li>)} </Typography> : ''}
                            {staffMember.links ? <Typography variant="body1"> <b>Links:</b>  {staffMember.links.map(i => <li>{i}</li>)} </Typography> : ''}
                        </CardContent>
                    </Collapse>
                </Card>
            </Grid>
        )
    }
}

export default withStyles(styles)(StaffCard)